export const storeMounted = (state)=>{
    state.mounted = true;
}

export const storeScreenSize = (state, size)=>{state.screenSize = size};

export const storeUser = (state, user)=>{
    state.user = user;
}

export const storeDays = (state, activeDays)=>{
    state.activeDays = activeDays;
}

export const storeSelectedDayHours = (state, hours) =>{
    //state.selectedHour = '';//(hours[0]) ? hours[0].split('-')[3]: '00';
    state.selectedDayHours = hours;
}

export const storeSelectedHour = (state, data) => {
    if(state.selectedHour == data.hour){
        state.selectedHour = state.selectedHour+' ';
    }
    else
        state.selectedHour = data.hour; 

    //if(!data.loading && state.mounted)
    //    state.realtimeEnabled = false;
}
export const storeSelectedDay = (state, data) =>{
    state.selectedHour = '';
    state.selectedDay = data.day;
    //if(!data.loading && state.mounted)
     //   state.realtimeEnabled = false;
}
export const storeSidebarVisible = (state, visible) =>{state.sidebarVisible = visible;}

export const storeStatus = (state, status) =>{
    state.status.noiseError = (status['noise-status']=='error');
    state.status.noise = (status['noise-status']=='active' || state.status.noiseError);

    state.status.weatherError = (status['weather-status']=='error');
    
    state.status.noiseErrorMessage = status['noise-err'];
    state.status.noiseCode = status['noise-err_c'];
    state.status.weatherErrorMessage = status['weather-err'];
    state.status.weatherCode = status['weather-err_c'];

    state.status.adioError = (status['adio-status']=='error');
    state.status.adioError = (status['adio-status']=='error');
    
    state.status.adio = (status['adio-status']=='active' || state.status.adioError);
    state.status.adioErrorMessage = status['adio-err'];
    state.status.adioCode = status['adio-err_c'];    


    //DEVELOPTMEN
    //state.status.weatherError = (Math.random()>0.5);

    state.status.weather =  (status['weather-status']=='active' || state.status.weatherError);

    state.status = JSON.parse(JSON.stringify(state.status));

    
}
export const storeWeatherStatus = (state, status) =>{
    state.status.weather = status;
}
export const storeNoiseStatus = (state, status) =>{
    state.status.noise = status;
}
export const storeAdioStatus = (state, status) =>{
    state.status.adio = status;
}

export const storeSystemStatus = (state, status)=>{
    //status.cam_sd_percent = 90;
    state.systemStatus = status;
}

export const storeFirmware = (state, status) =>{ //ADDED
    state.firmware = status;
}

export const storeSelectedInterval = (state, selectedInterval) =>{
    state.selectedInterval = selectedInterval;
}

export const storeRealtimeEnabled = (state,enabled) =>{
    state.realtimeEnabled = enabled;
}

export const storeDownloading = (state, isDownloading)=>{
    state.isDownloading = isDownloading;
}
export const storeDownloadingProgress = (state, progress)=>{
    state.isDownloading.progress = progress;
    state.isDownloading.preparing = false;
}

/*SETTINGS */
export const storeLocalSettings = (state,data)=>{
    var localStorage = data.localStorage;
    var settings = data.settings;

    if (settings && !settings.markers){
        settings.markers = [];
    }

    localStorage.set('settings', JSON.stringify(settings));
    localStorage.set('settingsV', state.firmware.epoch);
    
    state.localSettings = JSON.parse(JSON.stringify(settings));
    state.unsavedLocalSettings = JSON.parse(JSON.stringify(settings));
}
export const createUnsavedLocalSettings = (state)=>{
    state.unsavedLocalSettings = JSON.parse(JSON.stringify(state.localSettings));
}

export const storeSettings = (state, settings)=>{
    if(settings && settings.ftp){
        mutateSettingsFTPSending(settings.ftp);
    }
    if(settings && settings.device && settings.device.valsel){
        mutateSettingsDevice(settings.device, state);
    }
    if(settings && settings.weather){
        mutateSettingsWeather(settings.weather, state);
    }
    if (settings && !settings.startstop){
        settings.startstop = {};
    }
    mutateSettingsAudio(settings.audio, settings.weather);
    mutateSettingsSystem(settings.system);
    mutateSettingsSpecval(settings.specval,state);
    mutateSettingsAlerts(settings.alerts, state);

    if(!settings.statistics){settings.statistics = {}}
    mutateSettingsStatistics(settings.statistics, state);
    mutateSettingsStartstop(settings.startstop, state);

    //settings.addons.weather = 0;
    //settings.addons.video = 0;
    //settings.addons.markers = '1';

    if(!settings.adio)
        settings.adio = {
            digitalOut1:undefined,
            digitalOut2:undefined,
            digitalIn1:undefined,
            digitalIn2:undefined,
            analogOut:undefined,
            analogIn:undefined,
            analogLower:30,
            analogUpper:150,
        };

    state.settings = settings;
}

export const status = (state, systemStatus) =>{
    state.systemStatus = systemStatus;
}

export const updateStatisticsSettings = (state, statisticsSettings)=>{
    state.settings.statistics = statisticsSettings;
}

export const updateStartstopSettings = (state, startstopSettings)=>{
    state.settings.startstop = startstopSettings;
}

function mutateSettingsStartstop(settings, state){
    //settings.groups = 'gr1,gr2';
    if(settings.groups != ''){
        settings.groups = settings.groups.split(',');
        settings.groups.forEach(g=>{
            if (settings['days'+g] == ""){
                settings['days'+g] = []
            } else {
                settings['days'+g] = settings['days'+g].split(',');
            }
            //settings['start'+g] = '12:00';
            //settings['stop'+g] = '22:00';
            if (settings['types'+g] ==""){
                settings['types'+g] = [];
            } else {
                settings['types'+g] = settings['types'+g].split(',')

            }
            
            settings['enable'+g] = (settings['enable'+g] == '1') ? true:false;
        })
    }else {
        settings.groups = [];
    }
}

function mutateSettingsStatistics(settings, state) {
    if (!settings) settings = {};
    if(!settings.groups) settings.groups = '';

    settings.allgroups = settings.groups.split(',');
    
    //FIX 
    //settings.allgroups = "";
    //settings.vallAll = ''
    
    if (settings.allgroups != "") {
        settings.allgroups.forEach(g=>{

            let id = g.replace('st','');

            let dayss =  settings['dayss'+id].split(',');
            if (dayss == undefined || (dayss.length == 1 && dayss[0]== '')) dayss = [];
            settings['dayss'+id] = dayss;

            let ranges =  settings['ranges'+id].split(',');
            if (ranges == undefined) ranges = [];
            settings['ranges'+id]  = ranges;

        })
    } else {
        settings.allgroups =[]
    }
}


//DEMUTATE TREBA NAPISAT ZA MUTATE KJER JE ADDED DOPISAN
function mutateSettingsWeather(settings, state){
    settings.windsptrig = settings.windsptrig.split(',').map(num => parseFloat(num)); // ADDED
    settings.temptrig = settings.temptrig.split(',').map(num => parseFloat(num)); // ADDED
    settings.humidtrig = settings.humidtrig.split(',').map(num => parseFloat(num)); // ADDED
    settings.airprtrig = settings.airprtrig.split(',').map(num => parseFloat(num)); // ADDED
    settings.precipittrig = settings.precipittrig.split(',').map(num => parseFloat(num)); // ADDED

    settings.windsptrigtype = getThresholdType(settings.windsptrig); // ADDED
    settings.temptrigtype = getThresholdType(settings.temptrig); // ADDED
    settings.humidtrigtype = getThresholdType(settings.humidtrig); // ADDED
    settings.airprtrigtype = getThresholdType(settings.airprtrig); // ADDED
    settings.precipittrigtype = getThresholdType(settings.precipittrig); // ADDED

    
    settings.valall = settings.valall.split(',');
    var valsel = [];
    var valselSplit = settings.valsel.split(',');

    var downlweath = state.localSettings.download.downlweath;
    state.localSettings.interface.colorsWeather = {};
    var count = 0;
    settings.valall.forEach(item=>{
        if(valselSplit.indexOf(item) > -1){
            valsel.push({name:item, enabled:true})
        }else{
            valsel.push({name:item, enabled:false})
        }

        if(!downlweath[item]){
            downlweath[item] = '';
        }

        if(state.localSettings.interface.colorsweath[count]){
            state.localSettings.interface.colorsWeather[item] = state.localSettings.interface.colorsweath[count];
        }
        count++;
    })
    settings.oldValsel = settings.valsel;
    settings.valsel = valsel;
    state.localSettings.download.downlweath = JSON.parse(JSON.stringify(downlweath));
}

function mutateSettingsFTPSending(FTPSending){
    try{
        FTPSending.valall = FTPSending.valall.split(',');
        var valsel = [];
        var valselSplit = FTPSending.valsel.split(',');
        FTPSending.valall.forEach(item=>{
            if(valselSplit.indexOf(item) > -1){
                valsel.push({name:item, enabled:true})
            }else{
                valsel.push({name:item, enabled:false})
            }
        })
        FTPSending.oldValsel = FTPSending.valsel;
        FTPSending.valsel = valsel;
    }catch(err){}
}

function mutateSettingsDevice(device, state){
    device.valall = device.valall.split(',');
    device.valsel = device.valsel.split(',');

    var valuesAll = [];
    for(var i = 0; i < device.valall.length; i++){
        var value = device.valall[i];
        switch(value[2]){
            case 'F':
                valuesAll.push([
                    device.valall[i],
                    device.valall[i+1],
                    device.valall[i+2],
                ]);
                i+=2
                break;
            case 'E':
                valuesAll.push([
                    device.valall[i],
                    device.valall[i+1],
                ]);
                i+=1;
                break;
            case 'P':
                valuesAll.push([device.valall[i]]);
                break;
        }
    }
    device.valuesAll = valuesAll;
    if (state.localSettings.download){
        var downlnoise = state.localSettings.download.downlnoise;
    
        device.valall.forEach(item=>{
            if(!downlnoise[item]){
                downlnoise[item] = '';
            }
        });
        state.localSettings.download.downlnoise = JSON.parse(JSON.stringify(downlnoise));

    }

    if (state.localSettings.interface){
        state.localSettings.interface.noiseValues = valuesAll;
    }
    /*[['LAFSPL', 'LASSPL', 'LAISPL'],
    ['LAEQ', 'LAIEQ'],
    ['LAFMAX', 'LASMAX', 'LAIMAX'],
    ['LAFMIN', 'LASMIN', 'LAIMIN'],
    ['LCFSPL', 'LCSSPL', 'LCISPL'],
    ['LCEQ', 'LCIEQ'],
    ['LCFMAX', 'LCSMAX', 'LCIMAX'],
    ['LCFMIN', 'LCSMIN', 'LCIMIN'],
    ['LAE', 'LAIE'],
    ['LfFSPL', 'LfSSPL', 'LfISPL'],
    ['LfEQ', 'LfIEQ'],
    ['LfFMAX', 'LfSMAX', 'LfIMAX'],
    ['LfFMIN', 'LfSMIN', 'LfIMIN'],
    ['LAPeak'],
    ['LCPeak'],
    ['LCE', 'LCIE'],
    ['LFE', 'LFIE']]*/
    
}


function mutateSettingsAudio(audio, weather){
    //DEMUTATE TREBA NAPISAT ZA MUTATE KJER JE ADDED DOPISAN
    audio.threshold1 = audio.threshold1.split(',').map(num => parseFloat(num)); // ADDED
    audio.threshold2 = audio.threshold2.split(',').map(num => parseFloat(num)); // ADDED
    audio.threshold3 = audio.threshold3.split(',').map(num => parseFloat(num)); // ADDED
    audio.threshold4 = audio.threshold4.split(',').map(num => parseFloat(num)); // ADDED

    audio.threshold1type = getThresholdType(audio.threshold1); // ADDED
    audio.threshold2type = getThresholdType(audio.threshold2); // ADDED
    audio.threshold3type = getThresholdType(audio.threshold3); // ADDED
    audio.threshold4type = getThresholdType(audio.threshold4); // ADDED

    audio.duration1Picker = new Date(2017,1,1,0,0,audio.duration1)
    audio.duration2Picker = new Date(2017,1,1,0,0,audio.duration2)
    audio.duration3Picker = new Date(2017,1,1,0,0,audio.duration3)
    audio.duration4Picker = new Date(2017,1,1,0,0,audio.duration4)
    weather.rectimePicker = new Date(2017,1,1,0,0,weather.rectime);
    
}

//Used twice for getting weather types and audio type, in weather disabled means -100 in audio it means -20
function getThresholdType(numbers){
    var counter = 0;
/*
    for(var i = 0; i < numbers.length; i++){
        if(counter == 0 && numbers[i] == -10){
            return 0;
        }
        else if(numbers[i] == -20 || numbers[i] ==  -100){
            switch(counter){
                case 0: return 2;
                case 1: return 1;
            }
        }
        else{
            counter++;
        }
    }
    return 3;
*/
    if (numbers.length > 1) {
        if(numbers[0] == -20 || numbers[0] ==  -100){
            if(numbers[1] == -100 || numbers[1] ==  140){
                return 0;
            } else {
                return 2;
            }
        } else if(numbers[1] == -100 || numbers[1] ==  140){
            return 1;
        } else {
            return 3;
        }
    } 
    return 0;
}

function mutateSettingsSystem(settings){
    try{
        settings.delvalall = settings.delvalall.split(',');
        var delvalsel = [];
        var delvalselSplit = settings.delvalsel.split(',');
        settings.delvalall.forEach(item=>{
            delvalsel.push({name:item, enabled:(delvalselSplit.indexOf(item)> -1)});
        })
        settings.delvalselOld = settings.delvalsel;
        settings.delvalsel = delvalsel;
    }catch(err){}
}

function mutateSettingsSpecval(specval, state){
    //DEMUTATE TREBA NAPISAT ZA MUTATE KJER JE ADDED DOPISAN
    specval.mavallevel = specval.mavallevel.split(','); // ADDED
    specval.mavalltype = getThresholdType(specval.mavallevel);

    specval.valallsp = specval.valallsp.split(',');
    if(specval.valallsp.indexOf('MV') == -1)
        specval.valallsp.push('MV');
    
        var valselsp = [];
    var valselspSplit = specval.valselsp.split(',');
    specval.valallsp.forEach(item=>{
        valselsp.push({name:item, enabled:(valselspSplit.indexOf(item)>-1)});
    })
    specval.oldvalselsp = specval.valselsp;
    specval.valselsp = valselsp;
    specval.global = specval.global.split(',');

    var downlGlobal = state.localSettings.download.downlGlobal;
   
    specval.global.forEach(item=>{
        if(typeof downlGlobal[item] == 'undefined')
            downlGlobal[item] = true;
    })
    state.unsavedLocalSettings.download.downlGlobal = JSON.parse(JSON.stringify(downlGlobal));

    specval.mavaldurationPicker = new Date(2017,1,1,0,0,specval.mavalduration)
}

function mutateSettingsAlerts(alerts, state){
    var allAlerts = ["threshday","threshnight","threshopt1","threshopt2","threshweath","mav","reboot","n140","ftperr","n140sd","discerr","micerr","battmode","weather","weatTrig","videotrig","videoerr","leqday"];
    
    if (alerts.groups == ""){
        alerts.groups = [];
    } else {
        alerts.groups = alerts.groups.split(',');
    }

    alerts.groups.forEach(group=>{
        var id = group.replace('gr','');
        
        //region alerts
        if(!alerts['alg'+id])
            alerts['alg'+id]='';

        alerts['alg'+id] = alerts['alg'+id].split(',');

        var gAlerts = {};
        allAlerts.forEach(alert=>{
            if(alerts['alg'+id].indexOf(alert)>-1){
                gAlerts[alert]=true;
            }
            else{
                gAlerts[alert]=false;
            }
        })
        alerts['alg'+id] = gAlerts;
        //endregion

        alerts['leqdg'+id] = alerts['leqdg'+id].split(',');
        alerts['recpg'+id] = alerts['recpg'+id].split(',').filter(a=>a != "");
        
        alerts['del'+id] = [];

        //day,night, opt1,opt2, running, LEQDay
        if(!alerts['repg'+id])
            alerts['repg'+id] = '0,0,0,0,0,0,0';
        alerts['repg'+id] = alerts['repg'+id].split(',');

        if(!alerts['lqtg'+id])
            alerts['lqtg'+id] = 'true,true,true';
        alerts['lqtg'+id] = alerts['lqtg'+id].split(',').map(a=>(a=='true'));
            
        
    })
}



// WEBPACK FOOTER //
// ./src/store/mutations.js